var _path, _path2, _path3, _ellipse, _ellipse2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 72,
    viewBox: "0 0 57 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5269 0.874268H7.64171C5.7928 0.874268 4.01963 1.61342 2.71226 2.92913C1.40488 4.24483 0.67041 6.02931 0.67041 7.89V64.0159C0.67041 65.8766 1.40488 67.6611 2.71226 68.9768C4.01963 70.2925 5.7928 71.0316 7.64171 71.0316H49.4695C51.3184 71.0316 53.0916 70.2925 54.3989 68.9768C55.7063 67.6611 56.4408 65.8766 56.4408 64.0159V21.9215L35.5269 0.874268Z",
    fill: "#F1F5FA",
    stroke: "#CCD2E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5254 0.874268V19.9215C35.5254 21.026 36.4208 21.9215 37.5254 21.9215H56.4393",
    fill: "#CCD2E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5254 0.874268V19.9215C35.5254 21.026 36.4208 21.9215 37.5254 21.9215H56.4393",
    stroke: "#CCD2E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.8493,
    cy: 35.8384,
    rx: 2.06123,
    ry: 2.07114,
    fill: "#8894AC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.4685,
    cy: 35.8384,
    rx: 2.06123,
    ry: 2.07114,
    fill: "#8894AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.459 47.0369C23.806 44.9992 30.0828 42.3456 35.8766 42.6166",
    stroke: "#5D6A86",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.b41bedceedddfd61ec9fbdb688ad0893.svg";
export { ForwardRef as ReactComponent };